import script from "./enarticlexq.vue?vue&type=script&setup=true&lang=js"
export * from "./enarticlexq.vue?vue&type=script&setup=true&lang=js"

import "./enarticlexq.vue?vue&type=style&index=0&id=79f336df&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f336df"]])

export default __exports__